enum KioskGuestReceiptMode {
  PrintOnlyCashOrders = 'print-only-cash-orders',
  PrintOnlyOnDemandOrders = 'print-only-on-demand-orders',
  PrintAllOrders = 'print-all-orders',
}

export { KioskGuestReceiptMode };
